import React from 'react'
import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import ControlledSelect from 'transfix-form/components/ControlledSelect'
import { ENTITY_TYPE_OPTIONS } from '../constants'
import { TCompanyInformationEditModalSchema } from './CompanyInformationEditModalSchema'
import { useCompanyInformationEditModalFormContext } from './useCompanyInformationEditModalForm'

const getErrorMessage = <
  T extends FieldErrors<TCompanyInformationEditModalSchema>,
  K extends keyof T
>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}

export const CompanyInformationEditModalForm = () => {
  const { control, errors } = useCompanyInformationEditModalFormContext()

  return (
    <form data-test='CompanyInformationEditModalForm'>
      <ControlledSelect
        control={control}
        name='entityType'
        SelectProps={{
          label: 'Entity Type',
          options: ENTITY_TYPE_OPTIONS,
          error: Boolean(getErrorMessage(errors, 'entityType')),
          validationMessage: getErrorMessage(errors, 'entityType'),
        }}
      />
    </form>
  )
}
